import { set } from '@/vuex/helpers';

export default {
  namespaced: true,
  state: {
    questionnaires: [],
    questionnaire: null,
  },
  mutations: {
    set,
  },
  actions: {
    async load({ commit }) {
      const questionnaires = await this.$axios.$get('/api_foreigner/survey/');
      commit('set', ['questionnaires', questionnaires]);
    },

    async loadByForeignerId({ commit }, { foreignerId }) {
      const questionnaires = await this.$axios.$get(`/api_foreigner/${foreignerId}/survey/`);
      commit('set', ['questionnaires', questionnaires]);
    },

    async loadQuestionnaire({ commit }, { questionnaireId }) {
      const questionnaire = await this.$axios.$get(`/api_foreigner/survey/${questionnaireId}/`);
      commit('set', ['questionnaire', questionnaire]);
    },

    async updateQuestionnaire({ commit }, { questionnaireId, payload, isCompleted }) {
      const questionnaire = await this.$axios.$patch(`/api_foreigner/survey/${questionnaireId}/`, payload);
      commit('set', ['questionnaire', questionnaire]);
    },
  },
};
